{
  "App": "应用程序",
  "Profile": "个人资料",
  "My Account": "我的账户",
  "Contacts": "联系人",
  "Preferences": "首选项",
  "Family Language": "家庭语言",
  "Program Consent": "计划同意书",
  "Yes": "是",
  "No": "否",
  "Not submitted": "没有提交",
  "See anything missing? Contact your Caring Adult": "有什么遗漏吗？联系您的成人看护人员",
  "Messages": "信息",
  "Caring Adult for": "成人看护人员",
  "Former Caring Adult for": "之前的成人看护人员",
  "Write your message here...": "在这里写下您的信息...",
  "I need help with": "我需要以下方面的帮助",
  "Academic": "学业",
  "After School/ Out of School": "课后/校外",
  "Applying for benefits": "申请福利",
  "Childcare": "儿童保育",
  "Employment / Adult Education": "就业/成人教育",
  "Food": "食品",
  "Housing": "住房",
  "Legal services": "法律服务",
  "Material Resources / Clothing / Laundry": "物质资源/衣物/洗衣",
  "Mental/emotional health": "心理/情绪健康",
  "Physical health/asthma": "身体健康/哮喘",
  "Transportation": "交通方式",
  "Send": "发送",
  "Today": "今天",
  "No messages yet": "还没有信息",
  "No messages": "没有信息",
  "Start a conversation below": "在下面开始对话",
  "This Caring Adult is no longer available": "成人看护人员不再可用",
  "No longer available ": "不再可用 ",
  "Monday": "周一",
  "Tuesday": "周二",
  "Wednesday": "周三",
  "Thursday": "周四",
  "Friday": "周五",
  "Saturday": "周六",
  "Sunday": "周日",
  "Emergency Contacts": "紧急联系人",
  "Supervisor of Social Workers for the Bronx": "布朗克斯区社工主管",
  "Student Services Manager, High School District": "高中学区学生服务经理",
  "Social Worker, Central Crisis Support Team": "中央危机支持小组 (Central Crisis Support Team) 社工",
  "Support Line": "支持热线",
  "Suicide and Crisis Lifeline": "自杀和危机生命线 (Suicide and Crisis Lifeline)",
  "Emergencies": "紧急情况",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "如果您正面临危及生命的紧急情况，需要立即获得帮助，请拨打911或发送短信",
  "About New Visions": "关于 New Visions",
  "Privacy and Terms": "隐私和条款",
  "Homepage": "主页",
  "Home Page": "主页",
  "My family": "我的家庭",
  "Available Services": "可用服务",
  "Grade": "年级",
  "School": "学校",
  "Attendance this year": "今年的出席率",
  "Absences last 5 days": "过去 5 天缺勤记录",
  "Caring Adult": "成人看护人员",
  "Message": "信息",
  "Not available": "不可用",
  "Not yet assigned": "尚未分配",
  "No absences": "无缺勤记录",
  "Phone not available": "电话不可用",
  "Email address not available": "电子邮件地址不可用",
  "January": "一月",
  "February": "二月",
  "March": "三月",
  "April": "四月",
  "May": "五月",
  "June": "六月",
  "July": "七月",
  "August": "八月",
  "September": "九月",
  "October": "十月",
  "November": "十一月",
  "December": "十二月",
  "Sidenav": "侧边导航",
  "Home": "主页",
  "Log out": "注销",
  "Accessibility": "辅助功能",
  "Skip to main content": "跳转到主要内容",
  "Email": "电子邮箱",
  "Phone": "电话",
  "Family Portal": "家庭门户网站",
  "Every Child and Family is Known": "了解每个儿童和家庭",
  "Family Portal: Every Child and Family is Known": "家庭门户网站：了解每个儿童和家庭",
  "Close menu": "关闭菜单",
  "Open menu": "打开菜单",
  "Notes": "备注",
  "Send message": "发送信息",
  "Languages": "语言",
  "Consent status": "同意状态",
  "Select": "选择",
  "Language selector": "语言选择器",
  "Sorry": "抱歉",
  "we couldn't find that page": "我们找不到该页面",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "您尚未获得登录家庭门户的授权。请联系您的关爱成人以获取访问权限。"
}